import React from 'react';
import { Button, Typography } from 'antd';

const SYMBOL_ROWS: string[][] = [
  ['±', 'Ø', '°', '×', '≤', '≥', '∠', '□', 'R', 'ø', '≈', 'mm', 'μm', 'M', 'm', '→', '~', '∼', '⌴', '+', '-', '/', '.'],
  ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '½', '⅓', '⅔', '¼', '¾', '⅕', '⅖', '⅗', '⅘', '⅙', '⅚', '⅐', '⅛'],
  ['⅜', '⅝', '⅞', '⅑', '⅒', '⁰', '¹', '²', '³', '⁴', '⁵', '⁶', '⁷', '⁸', '⁹', '⁻', '_', '(', ')', 'n/d'],
];

export interface EngineeringSymbolPaletteProps {
  disabled?: boolean;
  onInsert: (symbol: string) => void;
}

export const EngineeringSymbolPalette: React.FC<EngineeringSymbolPaletteProps> = ({ disabled, onInsert }) => {
  return (
    <div className="dimension-symbol-palette">
      <div className="dimension-symbol-palette__hint">
        <Typography.Text style={{ color: '#365880', fontSize: 16, fontWeight: 500 }}>
          Click input field, then tap symbol to insert
        </Typography.Text>
      </div>
      {SYMBOL_ROWS.map((row, rowIndex) => (
        <div
          key={rowIndex}
          className="dimension-symbol-palette__row"
          style={{ marginBottom: rowIndex < SYMBOL_ROWS.length - 1 ? 12 : 0 }}
        >
          <div className="dimension-symbol-palette__row-inner">
            {row.map((symbol, colIndex) => (
              <Button
                key={`${rowIndex}-${colIndex}-${symbol}`}
                type="default"
                size="large"
                className="dimension-symbol-palette__button"
                disabled={disabled}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => !disabled && onInsert(symbol)}
                style={{
                  minWidth: symbol.length > 1 ? Math.max(52, 14 + symbol.length * 8) : 52,
                  minHeight: 44,
                  height: 44,
                  fontSize: symbol.length > 1 && symbol !== 'n/d' ? 14 : 16,
                  padding: '0 10px',
                }}
              >
                {symbol}
              </Button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default EngineeringSymbolPalette;
